<template>
    <div>
        <div class="row" v-if="removeHtmlTags(html_content).length > emailCharactersLimit">
            <div class="col-12">
                <div class="alert alert-danger">
                    Este texto <strong>tiene demasiados caracteres</strong> para ser enviado por correo electrónico.
                </div>
            </div>
        </div>

        <div class="row template-container">
            <div class="col-6">
                <div class="loader" v-if="load_editor === false"></div>
                <html-editor :pcontent="html_content" height="90vh" width="100%" @contentChanged="fireEditorUpdated"
                             @isLoaded="tinyMCEIsLoaded" v-if="load_editor === true"></html-editor>
            </div>
            <div class="col-6">
                <pdf-previewer :src="pdf_preview_content" height="90vh" width="100%"></pdf-previewer>
            </div>
        </div>

        <div class="actions-buttons-section">
            <router-link
                class="btn btn-primary rounded-btn"
                :to="{name: 'expedient.template.data', params: {expedient: router.currentRoute.value.params.expedient, template: router.currentRoute.value.params.template}}">
                <span class="uq-icon bi-arrow-left"></span>
            </router-link>

            <router-link
                :to="{ name: 'expedient.index', query: { client: expedient.clients[0]['id'], page: 1 } }"
                v-if="expedient.clients && expedient.clients[0]">
                <button type="button" class="btn btn-primary">
                    <span class="uq-icon bi-arrow-left"></span> Volver a listado de expedientes del cliente
                </button>
            </router-link>

            <div class="buttons-container">
                <button type="button" title="Borrar versión guardada" class="btn btn-warning icon-wrapper rounded-btn"
                        @click="deleteChanges" v-if="Object.keys(previouslyGeneratedDocument).length > 0">
                    <span class="uq-icon bi-trash"></span>
                </button>

                <a
                    title="Enviar correo"
                    class="btn btn-secondary icon-wrapper rounded-btn"
                    @click="mailto"
                    v-if="html_content"
                >
                    <span class="uq-icon bi-envelope"></span>
                </a>

                <router-link
                    class="btn btn-outline-info rounded-btn btn-burofax"
                    title="Enviar Burofax"
                    :to="{name: 'expedient.template.burofax.preview', params: {expedient: router.currentRoute.value.params.expedient, template: router.currentRoute.value.params.template}}">
                    <span class="uq-icon bi-check2-square vertical-center"></span>
                </router-link>

                <button type="button" title="Descargar PDF" class="btn btn-danger icon-wrapper rounded-btn"
                        @click="downloadPDF" v-if="pdf_base64_content !== ''">
                    <span class="uq-icon bi-download"></span>
                </button>

                <button type="button" title="Recargar PDF" class="btn btn-outline-danger rounded-btn"
                        @click="applyPdfPreview">
                    <span class="uq-icon bi-arrow-counterclockwise vertical-center"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import router from "../../router";
import {getExpedient} from "../../helpers/requests/RequestsExpedients";
import {getTemplate} from "../../helpers/requests/RequestsTemplates";
import HtmlEditor from "./parts/HtmlEditor";
import {htmlToRawPreviewablePdf} from "../../helpers/requests/RequestsPDFs";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import PdfPreviewer from "./parts/PdfPreviewer";
import {parseHTML} from "../../helpers/requests/RequestsHTML";
import {downloadPdf} from "../../helpers/PDFUtils";
import {createBurofax} from "../../helpers/requests/RequestsBurofaxes";
import {
    deleteGeneratedDocument,
    getGeneratedDocumentWithUserExpedientAndTemplate,
    storeGeneratedDocument
} from "../../helpers/requests/RequestsGeneratedDocuments";

export default {
    name: "TemplatePreviewPage",
    components: {
        PdfPreviewer,
        HtmlEditor
    },
    data() {
        return {
            status: {
                app: 'loading'
            },

            expedient: {},
            template: {},

            pdf_preview_content: '',
            pdf_base64_content: '',
            html_content: '',
            load_editor: false,

            timers: {
                preview_pdf: '',
            },

            previouslyGeneratedDocument: {},

            clientEmail: '',
        }
    },
    computed: {
        // TODO: This is also used in TemplateEdit.vue. Move it to only change once if needed
        emailCharactersLimit() {
            return 1200;
        }
    },
    async mounted() {
        await Promise.all([
            await this.loadExpedient(),
            await this.loadTemplate()
        ]);

        await this.saveSnapshot();
    },
    methods: {
        mailto() {
            if (this.removeHtmlTags(this.html_content).length > this.emailCharactersLimit) {
                alert('El texto es demasiado largo para ser enviado por correo electrónico. Redúcelo.');
                return;
            }

            let template_name = this.template.display_name;
            if (this.template.display_name.includes(' ')) {
                let x = this.template.display_name.split(' ');
                x.shift();
                template_name = x.join('');
            }

            let subject = '[' + this.expedient.clients[0].code + '] ' + this.expedient.entities[0].short_name + ': ' + template_name;

            location.href = 'mailto:' + this.clientEmail + '?subject=' + encodeURI(subject) + '&body=' + encodeURI(this.removeHtmlTags(this.html_content)) + '%0D%0A%0D%0A';
        },
        removeHtmlTags(html) {
            let dom = new DOMParser().parseFromString(html, 'text/html');
            return dom.body.textContent;
        },
        async loadExpedient() {
            this.expedient = await getExpedient(router.currentRoute.value.params.expedient);

            this.clientEmail = this.expedient.clients[0].email_01;
        },
        async loadTemplate() {
            this.template = await getTemplate(router.currentRoute.value.params.template);

            // Here we need to parse the template, but receive html
            let params = {
                client: this.expedient.clients[0].id,
                entity: this.expedient.entities[0].id,
                expedient: this.expedient.id,
            }
            if (this.expedient.lawyers.length > 0) {
                params.lawyer = this.expedient.lawyers[0].id;
            }
            if (this.expedient.attorneys.length > 0) {
                params.attorney = this.expedient.attorneys[0].id;
            }

            // We load previously generated documentation if exists, or just the template content
            this.previouslyGeneratedDocument = await getGeneratedDocumentWithUserExpedientAndTemplate(window.user.id, router.currentRoute.value.params.expedient, router.currentRoute.value.params.template);

            if (!!this.previouslyGeneratedDocument && !!this.previouslyGeneratedDocument.content) {
                // window.setTimeout(() => alert('Hemos cargado tu última versión del ' + new Date(this.previouslyGeneratedDocument.created_at).toLocaleString() + '. Puedes hacer clic en el botón de la papelera para empezar de cero o continuar con esta versión.'), 2000);
                this.html_content = this.previouslyGeneratedDocument.content;
            } else {
                this.html_content = await parseHTML(this.template.content, params);
            }

            this.load_editor = true;
        },
        async updatePdfPreview() {
            this.timers.preview_pdf = withTimeout(async () => {
                await this.applyPdfPreview();
                await this.saveSnapshot();
            }, this.timers.preview_pdf, 500);
        },
        async applyPdfPreview() {
            // Here we are editing only content, so we need to push header and footer
            let html = this.html_content;
            if (!!this.template.header) {
                html = this.template.header + html;
            }
            if (!!this.template.footer) {
                html = this.template.footer + html;
            }

            let pdf_content = await htmlToRawPreviewablePdf(html);
            this.pdf_base64_content = escape(pdf_content);
            this.pdf_preview_content = "data:application/pdf;base64," + escape(pdf_content);
        },
        async fireEditorUpdated(data) {
            this.html_content = data.content;
            await this.updatePdfPreview();
        },
        async tinyMCEIsLoaded() {
            await tinymce.activeEditor.setContent(this.html_content);
            await this.applyPdfPreview();
            this.status.app = 'loaded';
        },
        async downloadPDF() {
            await this.saveSnapshot();

            await downloadPdf(this.pdf_base64_content, this.expedient.clients[0].code + '_' + this.expedient.entities[0].short_name + '_' + this.template.display_name.replaceAll(' ', '-') + '.pdf');
        },
        async deleteChanges() {
            if (confirm('Se borrarán todos los cambios realizados hasta ahora y empezarás a editar desde 0. ¿Estás seguro?')) {
                await deleteGeneratedDocument(router.currentRoute.value.params.expedient, window.user.id, router.currentRoute.value.params.template, this.previouslyGeneratedDocument.id);
                window.location.reload();
            }
        },
        async saveSnapshot() {
            this.previouslyGeneratedDocument = await storeGeneratedDocument(this.html_content, this.template.content, router.currentRoute.value.params.expedient, router.currentRoute.value.params.template);
        },
        async burofaxPreview() {
            // console.log(router.currentRoute.value.params.expedient, router.currentRoute.value.params.template)
            await createBurofax(router.currentRoute.value.params.expedient, router.currentRoute.value.params.template);
        }
    },
    setup() {
        return {
            router,
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-burofax {
    margin-right: 1.25rem;
}
</style>
